import { useState, useEffect } from "react";

import classes from "./Button.module.css"

const Button = ({ text, onClick, activebutton, disabled }) => {
    const [isActive, setIsActive] = useState(activebutton);
  
    useEffect(() => {
      setIsActive(activebutton || false);
    }, [activebutton]);

    const handleClick = () => {
      if (typeof onClick === 'function') {
        onClick(); // Call onClick only if it's a function
      }
      setIsActive(!isActive);
    };
  
    return (
      <button
        className={`${classes.fotostudioButton} ${isActive ? classes.active : ''} mediumLarge`}
        onClick={handleClick}
        disabled={disabled}
      >
        <span>{text ? text : "Fotostudio"}</span>
        <div className={classes.box}>
          {isActive && (
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
              <rect x="1.3916" y="1.4502" width="18.5" height="18.5" rx="5" fill="#1F1F1F" stroke="#1F1F1F"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M15.0986 7.93103L8.77955 13.8302L8.77945 13.8301L8.77892 13.8306L6.09863 11.1433L6.70199 10.5636L8.80016 12.6672L14.5167 7.33057L15.0986 7.93103Z" fill="white"/>
            </svg>
          )}
        </div>
      </button>
    );
  };
  
  export default Button;
  